import React from "react";
import ItemButtonEdit from "./ItemButtons/ItemButtonEdit";
import ItemButtonDelete from "./ItemButtons/ItemButtonDelete";
import ItemButtonLogin from "./ItemButtons/ItemButtonLogin";
import ItemButtonEmpty from "./ItemButtons/ItemButtonEmpty";
import ItemButtonCustom from "./ItemButtons/ItemButtonCustom";

export default class EntityItemButtons extends React.Component {
  render() {
    return (
      <div className="item-edit">
        {Object.keys(this.props.actions).filter(action => action != "edit" && action != "delete" && action !="login").map(action => {
          return <ItemButtonCustom 
            id={this.props.id}
            action={this.props.actions[action]}
          />
        })}
        {this.props.actions.edit ? (
          <ItemButtonEdit id={this.props.id} action={this.props.actions.edit} />
        ) : (
          <ItemButtonEmpty />
        )}
        {this.props.actions.delete ? (
          <ItemButtonDelete
            id={this.props.id}
            action={this.props.actions.delete}
          />
        ) : (
          <ItemButtonEmpty />
        )}
        {this.props.actions.login && <ItemButtonLogin
            id={this.props.id}
            action={this.props.actions.login}
          />}
      </div>
    );
  }
}
